import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import { ScrollTrigger } from "../libraries/gsap"

export default class Sustainable extends Component {
  constructor(obj) {
    super(obj)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })
  }

  animate() {
    const titleTop = qsa(".title_top .line-0", this.el)
    const paragraphLeft = qsa(".text .line-0", this.el)
    const paragraphRight = qsa(".text_right .line-0", this.el)
    const img = qs(".img-wrapper img", this.el)
    const mainHeader = qs(".main-header")
    const bars = qsa(".bar-1, .bar-2, .bar-3")

    gsap.to(img, {
      width: "100%",
      height: "100%",
      duration: 1.2,
      scrollTrigger: {
        trigger: img,
        start: "top bottom",
      },
    })

    gsap.from(titleTop, {
      y: 100,
      duration: 1.2,
      scrollTrigger: {
        trigger: titleTop,
        start: "top bottom",
      },
    })

    gsap.from([paragraphLeft, paragraphRight], {
      y: 50,
      autoAlpha: 0,
      duration: 1.2,
      scrollTrigger: {
        trigger: paragraphLeft,
        start: "top bottom",
      },
    })

    const newArrivals = qs("[data-newArrivals]")
    const timeline = gsap.timeline({ paused: true })
    timeline.fromTo(
      [this.el, newArrivals],
      {
        backgroundColor: "#212520",
      },
      {
        backgroundColor: "#d6d3bf",
      },
      "<"
    )

    timeline.fromTo(
      mainHeader,
      {
        color: "#d6d3bf",
        fill: "#d6d3bf",
      },
      {
        color: "#53503e",
        fill: "#53503e",
      },
      "<"
    )

    timeline.fromTo(
      bars,
      {
        backgroundColor: "#d6d3bf",
      },
      {
        backgroundColor: "#53503e",
      },
      "<"
    )

    // d6d3bf
    // 53503e

    ScrollTrigger.create({
      trigger: this.el,
      start: "bottom bottom",
      end: "+=100%",
      onLeave: () => {
        mainHeader.style.color = ""
        mainHeader.style.fill = ""
        bars.forEach(bar => {
          bar.style.backgroundColor = ""
        })
      },
      onLeaveBack: () => {
        mainHeader.style.color = ""
        mainHeader.style.fill = ""
        bars.forEach(bar => {
          bar.style.backgroundColor = ""
        })
      },
      onUpdate: self => {
        timeline.progress(self.progress)
      },
    })
  }
}
